import RoleGuard from "@/components/common/RoleGuard/RoleGuard.vue";

export default [
  {
    path: "",
    component: RoleGuard,
    props: {
      allowedRoles: ["ADMINISTRATOR"],
      redirectPath: "/",
    },
    children: [
      {
        path: "/Setup/cluster",
        name: "ClusterList",
        component: () => import("../pages/cluster/ClusterListPage.vue"),
      },
      {
        path: "/Setup/cluster/add",
        name: "ClusterCreate",
        component: () => import("../pages/cluster/ClusterAddPage.vue"),
      },
      {
        path: "/Setup/cluster/:clusterId",
        name: "ClusterDetail",
        component: () => import("../pages/cluster/ClusterEditPage.vue"),
      },
    ],
  },
];
